package devxertech.com.pages.industries.sportsIndustry.sportsManagement


import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.component.FieldTitleTextNormalSimple
import devxertech.com.pages.industries.common.ManagementSoftware
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import devxertech.com.utils.Res
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.px

@Composable
fun SportsManagement() {
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()

    Box(
        modifier = Modifier
            .fillMaxWidth()
            .padding(top = if (breakpoint > Breakpoint.MD) 60.px else 45.px, bottom = 50.px),
        contentAlignment = Alignment.Center
    ) {
        Column(
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            FieldTitleTextNormalSimple(
                " Our All-in-One Sports Management Software services benefits",
                color = sitePalette.commonSecondaryButtonColor.rgb,
                fontSize = if (breakpoint > Breakpoint.MD) 18.px else 16.px,
                textAlign = TextAlign.Center,
                textTransform = TextTransform.Uppercase
            )
            Row(
                modifier = Modifier.flexWrap(FlexWrap.Wrap).margin(top = 0.px),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.Center
            ) {
                FieldTitleTextNormalSimple(
                    "User-Centric & ",
                    color = sitePalette.commonSecondaryButtonColor.rgb,
                    fontFamily = Constants.ROBOTO_FONT,
                    textTransform = TextTransform.Uppercase,
                    fontSize = if (breakpoint > Breakpoint.MD) 35.px else 22.px,
                    fontWeight = 700,
                    letterSpacing = 1.px
                )
                FieldTitleTextNormalSimple(
                    "Intuitive",
                    color = sitePalette.primary.rgb,
                    fontFamily = Constants.ROBOTO_FONT,
                    textTransform = TextTransform.Uppercase,
                    fontSize = if (breakpoint > Breakpoint.MD) 35.px else 22.px,
                    fontWeight = 700,
                    letterSpacing = 1.px
                )
            }

            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(top = if (breakpoint < Breakpoint.MD) 15.px else 50.px)
                    .margin(leftRight = 0.px).flexWrap(FlexWrap.Wrap),
                horizontalArrangement = Arrangement.Center
            ) {
                ManagementSoftware(
                    image = Res.Image.sport_user_1,
                    imageWidth = 85.px,
                    imageHeight = 87.px,
                    sideImage = Res.Image.inovative_common,
                    title = "Effortless Team & \n" +
                            "League Management",
                    description = "Streamline scheduling, roster management, and communication with " +
                            "automated workflows and centralized data."
                )
                ManagementSoftware(
                    image = Res.Image.sport_user_2,
                    imageWidth = 90.px,
                    imageHeight = 90.px,
                    sideImage = Res.Image.inovative_common,
                    title = "Real-Time Performance \n" +
                            "Tracking & Analytics",
                    description = "Gain deep insights into player stats, team performance, and game strategies with AI-powered analytics.",
                    )
                ManagementSoftware(
                    image = Res.Image.sport_user_3,
                    imageWidth = 89.px,
                    imageHeight = 87.px,
                    sideImage = Res.Image.inovative_common,
                    title = "Seamless Payment &\n" +
                            " Membership Handling",
                    description = "Secure and efficient payment processing for memberships, registrations, and event ticketing."
                )
                ManagementSoftware(
                    image = Res.Image.sport_user_4,
                    imageWidth = 90.px,
                    imageHeight = 90.px,
                    sideImage = Res.Image.inovative_common,
                    title = "Enhanced Fan & \n" +
                            "Player Engagement",
                    description = "Boost interaction through live updates, notifications, and integrated social media features."
                )
            }
        }
    }
}


